import { Component, Shark, Utils } from "shark-mvc";
import moment from "moment";

// import templateContent from "../../_shark_templates/views/site-info-sheet-outdoor-edit.html";
import applicatorTeamManager from "../_shark_jaws/managers/applicatorTeamManager";

class ApplicatorTeamComponent extends Component {
	constructor () {
		super("applicatorTeamComponent");
	}




		
	afterRender () {
		const applicatorTeamIdField = document.querySelector("#applicatorTeamId");

		if (applicatorTeamIdField) {
			const applicatorTeamId = applicatorTeamIdField.value;
			const applicatorTeamList = Shark.get("applicatorTeamList");
			const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", applicatorTeamId);

			const checkApplicatorTeamCalendarBtn = document.querySelector("#checkApplicatorTeamCalendarBtn");

			if (currApplicatorTeam) {
				checkApplicatorTeamCalendarBtn.href = currApplicatorTeam.calendarURL;
				checkApplicatorTeamCalendarBtn.classList.remove("d-none");
			}
			else {
				checkApplicatorTeamCalendarBtn.href = "";
				checkApplicatorTeamCalendarBtn.classList.add("d-none");
			}
		}
	}

	applicatorTeamId_changeHandler (event) {
		const applicatorTeamList = Shark.get("applicatorTeamList");
		const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", event.target.value);

		if (currApplicatorTeam) {
			const checkApplicatorTeamCalendarBtn = document.querySelector("#checkApplicatorTeamCalendarBtn");
		
			checkApplicatorTeamCalendarBtn.href = currApplicatorTeam.calendarURL;
			checkApplicatorTeamCalendarBtn.classList.remove("d-none");
		}
		else {
			checkApplicatorTeamCalendarBtn.href = "";
			checkApplicatorTeamCalendarBtn.classList.add("d-none");
		}
	}

	beforeLoad () {
		if (!Shark.get("applicatorTeamList") || Shark.get("applicatorTeamList").length === 0) {
			applicatorTeamManager.getList();
		}

		this.set({
			__todayISO: moment().format(Shark.get("dtIsoDate"))
		});
	}

	init () {
		Shark.set({
			applicatorTeamList: Shark.get("applicatorTeamList") || [],
		});
	}
}

const applicatorTeamComponent = new ApplicatorTeamComponent();

Shark.registerComponent(applicatorTeamComponent);

export { applicatorTeamComponent };
